<script>
/**
 * @overview 全局蒙板交互卡片组件
 *
 * @author huojinzhao
 */

export default {
  name: "AppMasker",

  props: {
    types: {
      type: String,
      default: "",
    },

    isJinyong: {
      type: Boolean,
      default: false,
    },
    // 复制权限
    isFuzhiPermissions: {
      type: Boolean,
      default: false,
    },
    // 移动权限
    isMovePermissions: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 权限
    isOpt(type) {
      let state = true;
      // 如果类型为 fuzhi 且有复制的权限 显示复制按钮
      switch (type) {
        case 'fuzhi':
          state = this.isFuzhiPermissions;
          break;
        case 'move':
          state = this.isMovePermissions;
          break;
      }
      return state;
    },
  },
};
</script>

<template>
  <AppCard
    v-bind="$attrs"
    class="app-masker"
  >
    <slot />

    <template
      v-for="type in types.split(',')"
    >
      <AppIcon
        v-if="isOpt(type)"
        slot="mask"
        :type="type"
        :key="type"
        :is-jinyong="isJinyong"
        @click="$emit(type)"
      />
    </template>
  </AppCard>
</template>

<style lang="postcss">
.app-masker {

}
</style>
